import { SportsGroupedByDateRequest } from "sb-bff-integration";
export var datesQueryFactory = function (from, timeRange, sportId) {
    return {
        id: sportId,
        eventState: SportsGroupedByDateRequest.EventStateEnum.PreLive,
        dateRange: {
            from: from,
            timeRange: timeRange
        }
    };
};
//# sourceMappingURL=DatesQueries.js.map